import AdaptiveImage from '@Hotels-at-Home/hah-fe-core/dist/components/AdaptiveImage';
import { IBaseProduct } from '@Hotels-at-Home/hah-fe-core/dist/types';

interface IProps {
  product: IBaseProduct;
}
const ExtendedContent = ({ product }: IProps) => {
  const hasVideoLink = product.video_link && product.video_link.trim() !== '';

  if (hasVideoLink) {
    return (
      <div className="extended-content">
        <video controls playsInline width={1044} height={490}>
          <source src={product.video_link} type="video/mp4" />
          <track kind="captions" />
          Your browser does not support the video tag.
        </video>
      </div>
    );
  }

  const extraImage = product.extra_image[0];
  const imageSrc = extraImage?.url_webp ?? extraImage?.url ?? '/images/product-placeholder.jpg';
  return (
    <div className="extended-content">
      <AdaptiveImage src={imageSrc} alt={product.image.label} width={1044} height={491} />
    </div>
  );
};

export default ExtendedContent;
